export const lineInitialValues = {
  nuLinha: '',
  deOrigem: '',
  deDestino: '',
  deDescricao: '',
  cdCategoria: '',
  cdSubSistema: '',
  cdLinhaOutorga: '',
  cdTipoVeiculo: '',
  cdMunicipioPolo: '',
  cdLinhaServico: '',
  nuPermissionarios: '',
  nuEdital: '',
  nuProcessoSei: '',
  nuProcesso: '',
  deObservacao: '',
  boAtivo: true,
};

export const lineStripInitialValues = {
  nuLinha: '',
  deOrigem: '',
  deDestino: '',
  deDescricao: '',
  deRazaoSocial:'',
  cdLinhaOutorga:'',
  nuTermoContrato:'',
  dtTermoContrato: '',
  cdOrgaoTermoContrato:'',
  cdLinhaServico:'',
  cdCategoria:'',
  cdTipoVeiculo:'',
  cdSubSistema:'',
  deObservacao: '',
  cdEmpresa: '',
  nuProcessoSei: '',
  nuProcesso: '',
  boAtivo: true,
};
